// Module
var code = "<div class=\"container\"> <section class=\"section\"> <h2> Login </h2> <p>Du musst dich zuerst anmelden bevor du fortfahren kannst.</p> <login-form></login-form> </section> </div>";
// Exports
export default code;